import { featureFlagFlags } from '@/plugins/rollout';
import { createApi } from '@stilingue/st-auth-utils';
import { isProdVersion } from '@stilingue/st-environment-controller-utils';
import Service from './Service';
import gateway from './Gateway';

const version = isProdVersion()
  ? featureFlagFlags.DbManagerServiceVersionProd.getValue()
  : featureFlagFlags.DbManagerServiceVersionStaging.getValue();

const afterParser = (response) => response;

class SendMailBeta extends Service {
  constructor(gateway, version) {
    const api = createApi(`email-service-dispatcher/${version}/`, gateway, {
      authNotFound: () => true,
      error401Handler: (error) => {
        return Promise.reject(error);
      },
    });

    super(api, {
      afterParser,
      retriesLimit: 3,
    });

    this.api.http.defaults.timeout = 300000;
  }

  sendMail(params) {
    params.templateId = process.env.VUE_APP_SENDGRID_ID;

    return this.api.post({ ...params, url: 'emails/send' });
  }
}

export default new SendMailBeta(gateway, version);
